import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import api from "../lib/api";
import MemberDetail, { money, fmtD } from "./MemberDetail";

const TAGS = {
  delinquent: ["Delinquent", "bg-rose-50 text-rose-700 border-rose-200"],
  notice: ["On notice", "bg-amber-50 text-amber-800 border-amber-200"],
  ending: ["Ending soon", "bg-sky-50 text-sky-700 border-sky-200"],
};

export default function NeedsAttention({ location }) {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get("/members/attention", { params: { location } }).then(({ data }) => setRows(data.members)).catch(() => setRows([]));
  }, [location]);

  if (rows === null) return <div className="h-24 rounded-xl bg-brand-surface border border-brand-border animate-pulse" />;
  return (
    <div className="rounded-xl border border-brand-border bg-brand-surface overflow-hidden" data-testid="needs-attention">
      {rows.length === 0 ? (
        <p className="px-5 py-6 text-sm text-brand-muted" data-testid="needs-attention-empty">All clear — no delinquent, on-notice or expiring members here.</p>
      ) : (
        <div className="divide-y divide-brand-border max-h-[420px] overflow-y-auto">
          {rows.map((m) => (
            <button key={m.company_id} onClick={() => setOpen(m.company_id)} data-testid={`attention-row-${m.company_id}`}
              className="w-full text-left px-5 py-3 flex flex-wrap items-center gap-x-4 gap-y-1 hover:bg-brand-hover transition-colors">
              <span className="text-sm font-medium text-brand-ink min-w-[160px] flex-1 flex items-center gap-1.5">
                {m.reasons.includes("delinquent") && <AlertTriangle className="h-3.5 w-3.5 text-rose-600" />}{m.company_name}
              </span>
              <span className="text-xs text-brand-muted w-24">{m.offices.join(", ") || "Coworking"}</span>
              <span className="text-xs text-brand-ink w-20 text-right">{money(m.mrr)}</span>
              <span className="text-xs text-brand-muted w-28">{m.leave_date ? `Leaves ${fmtD(m.leave_date)}` : ""}</span>
              <span className="flex gap-1">
                {m.reasons.map((r) => <span key={r} className={`text-[10px] rounded-full border px-2 py-0.5 ${TAGS[r][1]}`}>{TAGS[r][0]}</span>)}
              </span>
            </button>
          ))}
        </div>
      )}
      {open && <MemberDetail companyId={open} onClose={() => setOpen(null)} />}
    </div>
  );
}
